(function(){'use strict';
// Inject minimal CSS only for track layout
var st=document.createElement('style');
st.textContent='.fs9-track{display:flex;gap:3px;height:16px;margin:12px 0 8px}.fs9-seg{flex:1;height:100%;border-radius:3px;transition:all .3s ease}';
document.head.appendChild(st);

function load(){
var c=document.getElementById('fs9-track');
if(!c){setTimeout(load,300);return}

// Create 9 segments
c.innerHTML='';
for(var i=0;i<9;i++){var s=document.createElement('div');s.className='fs9-seg';c.appendChild(s)}
var segs=c.children;
var msg=document.getElementById('fs9-msg'),nx=document.getElementById('fs9-next'),dc=document.getElementById('fs9-disc'),ml=document.querySelectorAll('.fs9-mile');

function u(t){
var fill=Math.floor(t/100000);fill=Math.min(fill,9);fill=Math.max(fill,0);
// Set segment colors directly via JS (bypasses CSS issues)
for(var i=0;i<9;i++){
var bg='#e0e0e0'; // empty = gray
if(i<fill){bg=(i<3?'#c62828':i<6?'#e65100':'#2e7d32')} // filled: red/orange/green
else if(i===fill){bg=(i<3?'#c62828':i<6?'#e65100':'#2e7d32')} // pulsing = same color
segs[i].style.background=bg;
segs[i].style.opacity=(i<fill?'1':i===fill?'.6':'1');
}

// Milestones
[].forEach.call(ml,function(e){
t>=parseInt(e.getAttribute('data-t'),10)?e.classList.add('ok'):e.classList.remove('ok')
});

// Messages
var n=(300000-t)/100;
t>=900000?msg.textContent='🎉 5% off + Free Shipping! All tiers unlocked!':
t>=600000?msg.textContent='🎉 2.5% off + Free Shipping! Keep going for 5%!':
t>=300000?msg.textContent='🎉 Free Shipping unlocked! Go for 2.5% off!':
t>0?msg.textContent='🔥 Add '+n.toLocaleString('en-EG',{minimumFractionDigits:0})+' EGP more for Free Shipping!':
msg.textContent='🛒 Add 3,000 EGP to cart for Free Shipping!';

t>=900000?nx.textContent='🏆 Best deal active!':
t>=600000?nx.textContent='Add '+((900000-t)/100).toLocaleString('en-EG',{minimumFractionDigits:0})+' EGP more for 5% off!':
t>=300000?nx.textContent='Add '+((600000-t)/100).toLocaleString('en-EG',{minimumFractionDigits:0})+' EGP more for 2.5% off!':
t>0?nx.textContent='Add '+n.toLocaleString('en-EG',{minimumFractionDigits:0})+' EGP more for Free Shipping':
nx.textContent='';

t>=900000?dc.textContent='✓ 5% + Free Shipping at checkout':
t>=600000?dc.textContent='✓ 2.5% + Free Shipping at checkout':
t>=300000?dc.textContent='✓ Free Shipping at checkout':
dc.textContent='';
}

var x=new XMLHttpRequest;
x.open('GET','/cart.js',!0);
x.onload=function(){try{u(JSON.parse(x.responseText).total_price||0)}catch(e){}};
x.send();
document.addEventListener('cart:updated',function(){x.send()});
document.addEventListener('cart:added',function(){x.send()});
document.addEventListener('cart:removed',function(){x.send()});
document.addEventListener('cart:changed',function(){x.send()});
setInterval(function(){x.send()},2000);
}
load()})();
